import { render, staticRenderFns } from "./liaTableComponent2.vue?vue&type=template&id=010b42db&scoped=true"
import script from "./liaTableComponent2.vue?vue&type=script&lang=js"
export * from "./liaTableComponent2.vue?vue&type=script&lang=js"
import style0 from "./liaTableComponent2.vue?vue&type=style&index=0&id=010b42db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b42db",
  null
  
)

export default component.exports